import { autoserialize } from 'cerialize';

import { CourierType } from './courier-type';
import { Pricing } from './pricing';

export class Quote implements IQuote {
  @autoserialize courier: CourierType;
  @autoserialize quote_id: string;
  @autoserialize store_id: string;
  @autoserialize expires_at: string | null;
  @autoserialize quote_type: string;
  @autoserialize uber_organization: string;
  @autoserialize total_amount: number; //original quote
  @autoserialize discount_amount: number;
  @autoserialize application_fee: number;
  @autoserialize stripe_fee: number;

  constructor(payload: IQuote) {
    this.courier = payload?.courier;
    this.quote_id = payload?.quote_id;
    this.store_id = payload?.store_id;
    this.expires_at = payload?.expires_at;
    this.quote_type = payload?.quote_type;
    this.total_amount = payload?.total_amount;
    this.discount_amount = payload?.discount_amount;
    this.application_fee = payload?.application_fee;
    this.stripe_fee = payload?.stripe_fee;
    this.uber_organization = payload?.uber_organization;
  }

  public static OnSerialized(instance: Quote, json: Quote): void {
    json.total_amount = json.total_amount !== null ? json.total_amount * 100 : null;
    json.discount_amount = json.discount_amount !== null ? json.discount_amount * 100 : null;
    json.application_fee = json.application_fee !== null ? json.application_fee * 100 : null;
    json.stripe_fee = json.stripe_fee !== null ? json.stripe_fee * 100 : null;
  }

  public static OnDeserialized(instance: Quote): void {
    instance.total_amount = instance.total_amount ? Pricing.formatPrice(instance.total_amount / 100) : null;
    instance.discount_amount = instance.discount_amount ? Pricing.formatPrice(instance.discount_amount / 100) : null;
    instance.application_fee = instance.application_fee ? Pricing.formatPrice(instance.application_fee / 100) : null;
    instance.stripe_fee = instance.stripe_fee ? Pricing.formatPrice(instance.stripe_fee / 100) : null;
  }
}

export interface IQuote {
  courier: CourierType;
  quote_id: string;
  store_id: string;
  expires_at: string | null;
  quote_type: string;
  uber_organization: string;
  total_amount: number;
  discount_amount: number;
  application_fee: number;
  stripe_fee: number;
}
